<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-09-08 10:46:28
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2025-02-13 17:48:04
 * @FilePath: /wemeet-admin-new/src/views/marketing/components/addPointsPerson.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer userInfoDrawer"
    :direction="direction"
    :size="size"
    :title="title"
  >
    <el-form ref="reasonRef" :label-position="labelPosition" :label-width="150" :model="form" :rules="rules">
      <el-form-item label="获取积分总人数" prop="totalQuota">
        <el-input v-model="form.totalQuota" disabled type="text" />
      </el-form-item>
      <el-form-item label="已获取积分人数" prop="getPointsPeopleNum">
        <el-input v-model="form.getPointsPeopleNum" disabled type="text" />
      </el-form-item>
      <el-form-item label="剩余获取积分总人数" prop="remainingQuota">
        <el-input-number v-model="form.remainingQuota" :min="0" />
      </el-form-item>
      <el-form-item align="center">
        <el-button size="large" type="primary" @click="submit">提交</el-button>
      </el-form-item>
    </el-form>
  </el-drawer>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
  import { updateActivity, updatePrizes } from '@/api/exhibitionManage'
  import wmtImage from '@/components/wmt-image'
  import VueCropper from '@/extra/VueCropper'
  export default defineComponent({
    name: 'SendMessage',
    components: {
      wmtImage,
      VueCropper,
    },
    props: {
      meetingCode: {
        type: String,
        default: '',
      },
      meetingType: {
        type: String,
        default: 'EXHIBITION',
      },
    },
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()
      const state = reactive({
        imgUrl: '',
        brandLogoOption: {
          outputSize: 1, // 裁剪生成图片的质量
          outputType: 'jpeg', // 裁剪生成图片的格式 jpeg, png, webp
          info: true, // 裁剪框的大小信息
          canScale: true, // 图片是否允许滚轮缩放
          autoCrop: true, // 是否默认生成截图框
          autoCropWidth: 280, // 默认生成截图框宽度
          autoCropHeight: 280, // 默认生成截图框高度
          fixedBox: true, // 固定截图框大小 不允许改变
          fixed: false, // 是否开启截图框宽高固定比例，这个如果设置为true，截图框会是固定比例缩放的，如果设置为false，则截图框的狂宽高比例就不固定了
          fixedNumber: [1, 1], // 截图框的宽高比例 [ 宽度 , 高度 ]
          canMove: true, // 上传图片是否可以移动
          canMoveBox: true, // 截图框能否拖动
          original: false, // 上传图片按照原始比例渲染
          centerBox: true, // 截图框是否被限制在图片里面
          infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
          full: true, // 是否输出原图比例的截图
          enlarge: '1', // 图片根据截图框输出比例倍数
          mode: 'contain', // 图片默认渲染方式 contain , cover, 100px, 100% auto
        },
        dialogFormVisible: false,
        direction: 'rtl',
        size: '30%',
        detail: {
          attentFormDtoList: [],
        },
        title: '添加奖品',
        rules: {
          dailyLimit: [{ required: true, message: '请填写每日限额', trigger: 'blur' }],
          name: [{ required: true, message: '请填写奖品名称', trigger: 'blur' }],
          remainingQuota: [{ required: true, message: '请填写剩余人数', trigger: 'blur' }],
          stock: [{ required: true, message: '请填写库存', trigger: 'blur' }],
        },

        form: {
          reason: '',
          imgUrl: '',
        },
        reasonRef: null,
        row: null,
        labelPosition: 'left',
        vabCropperRef: null,
      })
      // 打开
      const handleOpen = async (row) => {
        if (row) {
          state.form = Object.assign(state.form, row)
          state.title = '设置限制人数'
        }
        state.dialogFormVisible = true
      }
      // 关闭
      const handleClose = () => {
        state.form = {}
        state.dialogFormVisible = false
      }

      const submit = async () => {
        state['reasonRef'].validate(async (valid) => {
          if (valid) {
            try {
              state.form.meetingCode = props.meetingCode
              const { data } = await updateActivity(state.form)
              proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            } catch (err) {
              console.log(err)
              proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
            }
            emit('fetch-data')
            handleClose()
          }
        })
      }

      const upLoadLogo = () => {
        state['vabCropperRef'].dialogVisible = true
      }

      const deleteImg = () => {
        state.imgUrl = ''
      }

      const logoInfo = (coverUrl) => {
        console.log('coverUrl', coverUrl)
        state.imgUrl = coverUrl
      }

      return {
        ...toRefs(state),
        handleOpen,
        handleClose,
        submit,
        upLoadLogo,
        deleteImg,
        logoInfo,
      }
    },
  })
</script>

<style lang="scss">
  .userInfoDrawer {
    .el-transfer-panel {
      width: 250px;
    }
    .hideLabel {
      .el-descriptions__label {
        display: none;
      }
    }
  }
</style>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }
  .containerForm {
    height: 85vh;
    overflow-y: auto;
  }
  .demo-drawer__footer {
    position: fixed;
    right: 20px;
    bottom: 10px;
  }
  .margin-top {
    margin-top: 20px;
  }

  .basicMessage {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    line-height: 50px;
    .desc {
      margin: 0 10px;
    }
  }
</style>
